import {
	RESET_PRODUCTS_FILTER,
	SET_PRODUCTS_FILTER_BY,
	UNSET_PRODUCTS_FILTER_BY,
} from "app/actionTypes";
import {
	REPLACE_PRODUCTS_FILTERS,
	SET_PRODUCTS_FILTERS,
	UNSET_PRODUCTS_FILTERS,
} from "app/pages/Listing/ProductFilters/productsFilterActionsTypes";
import { stringify } from "qs";

const initialState = {};

export default function productsFilters(productsFilter = initialState, action) {
	switch (action.type) {
		case SET_PRODUCTS_FILTER_BY: {
			const filters = Object.assign({}, productsFilter, action.filterBy);

			if (typeof window !== "undefined") {
				// window.filtre = `?filterBy=${encodeURIComponent(JSON.stringify(filters))}`;
				window.filtre = stringify(filters, {
					addQueryPrefix: true,
					sort: "alphabeticalSort",
				});
			}

			return filters;
		}
		case UNSET_PRODUCTS_FILTER_BY: {
			if (Object.prototype.hasOwnProperty.call(productsFilter, action.name)) {
				const filters = { ...productsFilter };
				delete filters[action.name];
				return filters;
			}
			return productsFilter;
		}
		case RESET_PRODUCTS_FILTER: {
			return initialState;
		}
		case UNSET_PRODUCTS_FILTERS: {
			const filters = { ...productsFilter };
			Object.keys(action.filters).forEach(filterKey => delete filters[filterKey]);
			return filters;
		}
		case SET_PRODUCTS_FILTERS: {
			if (action.filters.length) {
				return action.filters.reduce(
					(filtersAcc, filter) => ({
						...filtersAcc,
						[filter.key]: filter.value,
					}),
					{ ...productsFilters }
				);
			}
			return productsFilter;
		}
		case REPLACE_PRODUCTS_FILTERS: {
			return { ...initialState, ...action.filters };
		}
		default:
			return productsFilter;
		// return {};
	}
}
